import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled from 'styled-components'

import { truncate } from 'utils/strings'

import colors from 'components/utils/colors'

import IconLink from 'components/Shared/IconLink/Index'
import { MEGA_MENU_LINE_LENGTH } from 'constants/constants'

const StyledItem = styled.div`
  color: ${colors.secondary40};
  padding: 0 7px;
  height: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
  transition: all .25s linear;
  white-space: nowrap;
  border-bottom: 1px solid ${colors.secondary70};
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &.active, &:hover {
    color: ${colors.secondary20};
    a {
      visibility: visible;
    }
  }

  &.active {
    background-color: ${colors.primary80};
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      width: 4px;
      height: 100%;
      background-color: ${colors.primary40};
    }
  }

  &:hover {
    background-color: ${colors.primary90};
  }
`

const StyledIconLink = styled(Link)`
  visibility: hidden;
  position: absolute;
  right: 0;
  border-bottom: none !important;
  background-color: inherit;
`

const StyledInnerIconLink = styled(IconLink)`
  padding: 10px;
`

const StyledLogo = styled.img`
  margin-right: 4px;
  padding: 0 3px;
  height: 16px;
  width: 18px;
  border-radius: 8px;
  background-color: ${colors.secondary80};
`

const MegaMenuLinkToSubMenu = ({ name, to, itemId, active, icon, onClickHandler }) => {
  const handleClick = (e) => {
    e.stopPropagation()

    onClickHandler(itemId)
  }

  return (
    <StyledItem
      className={active ? 'active' : ''}
      onClick={(e) => handleClick(e)}
      onMouseEnter={(e) => e.currentTarget.focus()}
      tabIndex={0}
    >
      {icon &&
        <StyledLogo src={icon} />
      }

      {truncate(name, MEGA_MENU_LINE_LENGTH)}

      {to && (
        <StyledIconLink to={to}>
          <StyledInnerIconLink iconName='icon-switch-to-norm-12' />
        </StyledIconLink>
      )}
    </StyledItem>
  )
}

MegaMenuLinkToSubMenu.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  itemId: PropTypes.string,
  active: PropTypes.bool,
  icon: PropTypes.string,
  onClickHandler: PropTypes.func,
}

export default MegaMenuLinkToSubMenu
